import {Icons} from '~/common/fabric/Card/components/Icons/Icons';
import {MobileBox} from '~/common/fabric/CreateDesign/components/Background/Mobile/Contents/MobileBox';
import {EditorContainer} from '~/common/fabric/CreateDesign/components/Container/Mobile/EditorContainer';
import {useStamp} from '~/common/fabric/CreateDesign/components/Stamp/actions/useStamp';
import {Stickers} from '~/common/fabric/CreateDesign/components/Stamp/components/Stickers/Stickers';

export const StampEditorMobile = () => {
  const {stampIcons, onStampChange, selectedStamp} = useStamp();

  return (
    <EditorContainer>
      <MobileBox title="Stamps">
        <Icons
          icons={stampIcons}
          onClick={onStampChange}
          highlight={false}
          selectedIcon={selectedStamp?.image}
          square
          height={40}
          width={50}
          mobile
        />
      </MobileBox>
      <MobileBox title="Stickers">
        <Stickers />
      </MobileBox>
    </EditorContainer>
  );
};
